// src/pages/LandingPage.js
import React from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <Container
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <Row className="w-100">
        <Col className="d-flex flex-column flex-md-row justify-content-around mx-2">
          <Button
            variant="primary"
            onClick={() => navigate("/analytics")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Analytics
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate("/referrals")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Referrals
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate("/users")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Users
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate("/stagedUsers")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Staged Users
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate("/premium")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Applications
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate("/premiumMembers")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Premium Members
          </Button>

          <Button
            variant="primary"
            onClick={() => navigate("/deleteUser")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Delete User
          </Button>

          <Button
            variant="primary"
            onClick={() => navigate("/deleteDashboardData")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Delete Dashboard Tiles
          </Button>

          <Button
            variant="primary"
            onClick={() => navigate("/vectorDBCount")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            VectorDBCount
          </Button>

          <Button
            variant="primary"
            onClick={() => navigate("/matches")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Matches
          </Button>

          <Button
            variant="primary"
            onClick={() => navigate("/interests")}
            className="mx-2 my-2 my-md-0"
            style={{ backgroundColor: "rgb(72, 39, 110)" }}
          >
            Interests
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default LandingPage;
